import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'
import Vuelidate from 'vuelidate'
import router from '@/router';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueAlertify from 'vue-alertify'
import './registerServiceWorker'
import process_env from '@/config/dev.env.js'

Vue.use(VueGoogleMaps, {
  load: {
    key: process_env.KEY_GOOGLEMAPS,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})

Vue.use(VueAlertify,{
  notifier: {
    delay: 90,
    position: 'bottom-left'
  },
});

var VueCookie = require('vue-cookie');

Vue.use(Vuelidate)
Vue.use(GSignInButton)
Vue.use(FBSignInButton)
Vue.use(VueCookie);
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
